import React, { useState } from 'react';
import {
  IDateRange,
  IPersuasionContext,
  IPreviousPageName,
  ITravellerData,
  ICoupons,
} from 'src/international-insurance/interface';

export const TripInfoContext = React.createContext<any>({});

export const DefaultTravellers = [
  {
    index: 0,
    count: 0,
    category: 'adult',
    title: 'Adult',
    sub_title: '18-60 years',
  },
  {
    index: 1,
    count: 0,
    category: 'child',
    title: 'Child',
    sub_title: 'below 18 years',
  },
  {
    index: 2,
    count: 0,
    category: 'senior_citizen',
    title: 'Senior citizen',
    sub_title: '60-70 years',
    note: {
      icon_url: 'https://travel-uat-assets.ackodev.com/images/info.svg',
      text: 'We do not cover travellers aged 70 and above',
    },
  },
];

export const TripInfoContextProvider = ({ children }) => {
  const [tripDuration, setTripDuration] = useState<IDateRange>({
    start: null,
    end: null,
  });
  const [selectedCountries, setSelectedCountries] = useState<any>([]);
  const [travellerList, setTravellerList] =
    useState<ITravellerData[]>(DefaultTravellers);
  const [travellerDetails, setTravellerDetails] = useState<any>(null);
  const [travellerErrors, setTravellerErrors] = useState<any>(null);
  const [otherDetails, setOtherDetails] = useState<any>(null);
  const [otherDetailsErrors, setOtherDetailsErrors] = useState<any>(null);

  const contextValue = {
    tripDuration: { data: tripDuration, set: setTripDuration },
    selectedCountries: { data: selectedCountries, set: setSelectedCountries },
    travellers: { data: travellerList, set: setTravellerList },
    travellerDetails: { data: travellerDetails, set: setTravellerDetails },
    travellerErrors: { data: travellerErrors, set: setTravellerErrors },
    otherDetails: { data: otherDetails, set: setOtherDetails },
    otherDetailsErrors: {
      data: otherDetailsErrors,
      set: setOtherDetailsErrors,
    },
  };

  return (
    <TripInfoContext.Provider value={contextValue}>
      {children}
    </TripInfoContext.Provider>
  );
};

export const PersuassionContext = React.createContext<IPersuasionContext>({
  medical: {
    isActive: false,
    setIsActive: null,
  },
  flight: {
    isActive: false,
    setIsActive: null,
  },
  baggage: {
    isActive: false,
    setIsActive: null,
  },
  popUpStatus: { isActive: false, setIsActive: null },
  atlPopUpStatus: { isActive: false, setIsActive: null },
});

export const PersuassionContextProvider = ({ children }) => {
  const [medical, setMedical] = useState(true);
  const [flight, setFlight] = useState(true);
  const [baggage, setBaggage] = useState(true);
  const [popUp, setPopUp] = useState(true);
  const [altPopUp, setAtlPopUp] = useState(true);

  const contextValue: IPersuasionContext = {
    medical: { isActive: medical, setIsActive: setMedical },
    flight: { isActive: flight, setIsActive: setFlight },
    baggage: { isActive: baggage, setIsActive: setBaggage },
    popUpStatus: { isActive: popUp, setIsActive: setPopUp },
    atlPopUpStatus: { isActive: altPopUp, setIsActive: setAtlPopUp },
  };

  return (
    <PersuassionContext.Provider value={contextValue}>
      {children}
    </PersuassionContext.Provider>
  );
};

export const PreviousPageContext = React.createContext<IPreviousPageName>({
  previousPageName: null,
  setPreviousPageName: null,
});

export const PreviousPageContextProvider = ({ children }) => {
  const [previousPageName, setPreviousPageName] = useState<string | null>(null);

  const contextValue: IPreviousPageName = {
    previousPageName,
    setPreviousPageName,
  };

  return (
    <PreviousPageContext.Provider value={contextValue}>
      {children}
    </PreviousPageContext.Provider>
  );
};

export const CouponsContext = React.createContext<ICoupons>({
  coupons: null,
  setCoupons: null,
});

export const CouponsContextProvider = ({ children }) => {
  const [coupons, setCoupons] = useState([]);

  const contextValue: ICoupons = {
    coupons,
    setCoupons,
  };

  return (
    <CouponsContext.Provider value={contextValue}>
      {children}
    </CouponsContext.Provider>
  );
};

export const PostPaymentDetails = React.createContext<any>({
  healthAndNomineeDetails: null,
  setHealthAndNomineeDetails: () => {},
});

export const PostPaymentDetailsProvider = ({ children }) => {
  const [healthAndNomineeDetails, setHealthAndNomineeDetails] = useState<any>(
    []
  );

  const contextValue = {
    healthAndNomineeDetails,
    setHealthAndNomineeDetails,
  };

  return (
    <PostPaymentDetails.Provider value={contextValue}>
      {children}
    </PostPaymentDetails.Provider>
  );
};
